import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutComponent } from './about/about.component';
import { BusinesscardComponent } from './businesscard/businesscard.component';
import { GodlyComponent } from './businesscard/godly/godly.component';
import { IsraelComponent } from './businesscard/israel/israel.component';
import { JunaidShaikhComponent } from './businesscard/junaid-shaikh/junaid-shaikh.component';
import { NawazComponent } from './businesscard/nawaz/nawaz.component';
import { Nawaz2Component } from './businesscard/nawaz2/nawaz2.component';
import { ViewComponent } from './businesscard/view/view.component';
import { ContactComponent } from './contact/contact.component';
import { DnourComponent } from './dnour/dnour.component';
import { HomeComponent } from './home/home.component';
import { ProcessComponent } from './process/process.component';
import { ProjectsComponent } from './projects/projects.component';
import { PakhisComponent } from './pakhis/pakhis.component';
import { BeyouComponent } from './beyou/beyou.component';
import { AutokooroshComponent } from './autokoorosh/autokoorosh.component';
import { VendettaComponent } from './vendetta/vendetta.component';
import { SpacexComponent } from './spacex/spacex.component';
import { ServicesComponent } from './services/services.component';
import { BradingComponent } from './brading/brading.component';
import { WebsiteComponent } from './website/website.component';
import { EcommerceComponent } from './ecommerce/ecommerce.component';
import { GraphicsComponent } from './graphics/graphics.component';
import { StudioComponent } from './studio/studio.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { PaymentFailedComponent } from './payment-failed/payment-failed.component';
import { UnsubscriptionComponent } from './unsubscription/unsubscription.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { MiniaarComponent } from './miniaar/miniaar.component';
import { DetailMasterComponent } from './detail-master/detail-master.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { CasestudyComponent } from './casestudy/casestudy.component';
import { DemoCaseStudyComponent } from './demo-case-study/demo-case-study.component';
import { CrystalcargoComponent } from './crystalcargo/crystalcargo.component';

const routes: Routes = [
	{ path: '', component: HomeComponent },
	{ path: 'home', component: HomeComponent },
	{ path: 'process', component: ProcessComponent },
	// { path: 'about', component: AboutComponent },
	{ path: 'services', component: ServicesComponent },
	{ path: 'services/branding', component: BradingComponent },
	{ path: 'services/website-development', component: WebsiteComponent },
	{ path: 'services/ecommerce-web-development', component: EcommerceComponent },
	{ path: 'services/graphics', component: GraphicsComponent },
	{ path: 'studio', component: StudioComponent },
	{ path: 'projects', component: ProjectsComponent },
	{ path: 'contact', component: ContactComponent },
	{ path: 'contact/:id', component: ContactComponent },
	{ path: 'businesscard', component: BusinesscardComponent },
	{ path: 'businesscard/view/:id', component: ViewComponent },
	{ path: 'p/kbn', component: NawazComponent },
	{ path: 'p/kbn2', component: Nawaz2Component },
	{ path: 'p/js', component: JunaidShaikhComponent },
	{ path: 'p/io', component: IsraelComponent },
	{ path: 'p/godly', component: GodlyComponent },
	{ path: 'project-details/dnour', component: DnourComponent },
	{ path: 'project-details/demo', component: DemoCaseStudyComponent },
	{ path: 'project-details/crystalcargo', component: CrystalcargoComponent },
	{ path: 'project-details/miniaar', component: MiniaarComponent },
	{ path: 'project-details/detail-master', component: DetailMasterComponent },
	{ path: 'project-details/pakhis', component: PakhisComponent },
	{ path: 'project-details/beyou', component: BeyouComponent },
	{ path: 'project-details/autokoorosh', component: AutokooroshComponent },
	{ path: 'project-details/vendetta', component: VendettaComponent },
	{ path: 'project-details/spacex', component: SpacexComponent },
	{ path: 'payment-success', component: PaymentSuccessComponent },
	{ path: 'payment-success/:ispayament', component: PaymentSuccessComponent },
	{ path: 'payment-failed', component: PaymentFailedComponent },
	{ path: 'casestudy/:url_key', component: CasestudyComponent },
	// { path: 'unsubscription', component: UnsubscriptionComponent },
	{
		path: 'unsubscription/cancel/:subscriberID',
		component: UnsubscriptionComponent,
	},
	{
		path: 'unsubscription/pause/:subscriberID',
		component: UnsubscriptionComponent,
	},
	{
		path: 'unsubscription/resume/:subscriberID',
		component: UnsubscriptionComponent,
	},
	{ path: 'privacy-policy', component: PrivacyPolicyComponent },
	{ path: 'terms-and-conditions', component: TermsAndConditionsComponent },
	{ path: '**', component: PageNotFoundComponent },
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			initialNavigation: 'enabledBlocking',
			// useHash: true
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
